<template lang="pug">
  .follow-button
    v-btn(v-if="isFollowingNow" @click="unfollow()" :loading="isLoading" :min-width="260" tile)
      v-icon(left small) mdi-bell-off
      | フォロー解除
    v-btn(v-else @click="follow()" :loading="isLoading" :width="260" tile :disabled="userType>1")
      v-icon(left small) mdi-bell
      | {{buttonText}}
</template>

<script type="module">
import Axios from 'axios'

export default {
  props: {
    userType: {
      type: Number, // 0=guest, 1=user, 2=group,
      required: true
    },
    isFollowing: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    selfHelpGroupId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      isLoading: false,
      isFollowingNow: false
    }
  },
  computed: {
    buttonText: function () {
      if(this.userType === 2) {
        return '主催者はフォローできません'
      } else {
        return 'この居場所をフォロー'
      }
    },
    followDisabled: function () {
      return this.userType > 1
    }
  },
  created() {
    this.isFollowingNow = this.isFollowing
  },
  methods: {
    follow () {
      this.isLoading = true
      Axios.post(this.url + '.json', {self_help_group_id: this.selfHelpGroupId})
        .then(response => {
          this.isFollowingNow = true
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    unfollow () {
      Axios.delete(this.url+ `/${this.selfHelpGroupId}.json`)
        .then(response => {
          this.isFollowingNow = false
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.follow-button {
  margin-top: 20px;
}
</style>
